import { getFormatLocale, translateLabel } from "@/i18n/messages";
const WEATHER_LABELS = {
  CLEAR: "Clear",
  PARTLY_CLOUDY: "Partly cloudy",
  CLOUDY: "Cloudy",
  FOG: "Fog",
  DRIZZLE: "Drizzle",
  RAIN: "Rain",
  SNOW: "Snow",
  THUNDERSTORM: "Thunderstorm",
  UNKNOWN: "Unknown",
};

export const weatherConditionLabel = (condition) => translateLabel(WEATHER_LABELS[condition] || WEATHER_LABELS.UNKNOWN);

export const weatherDayLabel = (date) => {
  if (typeof date !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return translateLabel("Unknown day");
  const parsed = new Date(`${date}T12:00:00Z`);
  if (Number.isNaN(parsed.getTime())) return translateLabel("Unknown day");
  return new Intl.DateTimeFormat(getFormatLocale(), { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" }).format(parsed);
};

const rounded = (value) => Number.isFinite(value) ? Math.round(value) : null;

export const temperatureRangeLabel = (day) => {
  const min = rounded(day?.temp_min_c);
  const max = rounded(day?.temp_max_c);
  if (min != null && max != null) return `${min}–${max}°C`;
  if (max != null) return translateLabel("Max {value}°C", { value: max });
  if (min != null) return translateLabel("Min {value}°C", { value: min });
  return "—";
};

export const precipitationLabel = (day) => {
  const probability = rounded(day?.precipitation_probability_pct);
  const amount = Number.isFinite(day?.precipitation_mm) ? `${day.precipitation_mm.toFixed(1)} mm` : null;
  if (probability != null && amount) return `${probability}% · ${amount}`;
  if (probability != null) return `${probability}%`;
  return amount || "—";
};

export const windLabel = (day) => Number.isFinite(day?.wind_max_kmh)
  ? `${Math.round(day.wind_max_kmh)} km/h`
  : "—";

export const forecastView = ({ loading, error, forecast }) => {
  if (loading) return { kind: "loading", days: [] };
  if (error) return { kind: "error", days: [] };
  const days = Array.isArray(forecast?.days) ? forecast.days.slice(0, 7) : [];
  if (days.length === 0) return { kind: "empty", days: [] };
  return { kind: "ready", days };
};
